// [2026-10-29] โยกเครดิต 2 กระเป๋า: กระเป๋าหลัก (AMB) <-> กระเป๋า UFA — แบบเดียวกับเว็บลาว (Ufa11New /bwufa/wallet-transfer.js)
//   ใช้ API เดิมของ serverreward: /api/v1/wallet/balances · /transfer · /transferlog (ตรวจ token ฝั่ง server)
//   กฎความปลอดภัย (ตัดต้นทางก่อน / PENDING ห้ามคืนเอง / ล็อกต่อยูส / หน่วงระหว่างโยก) อยู่ฝั่ง server ทั้งหมด (walletTransfer.js)
//   หน้าตา: ใช้คลาส/สีของธีมเว็บ (x-login-index, x-title-modal, bg-profile-box-overview, text-white-v1, btn-primary = สีหลักธีม)
//   ภาษา: 5 ภาษา (i18nWallet.js) — ไทย / EN / ລາວ / 中文 / မြန်မာ
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import instance from './axios-instance';
import Systems from './SystemFunction';
import { wt, wtSrv, wtLang } from './i18nWallet';

const DIR = { AB: 'MAIN_TO_UFA', BA: 'UFA_TO_MAIN' };
const NAME = { get A() { return wt('main'); }, get B() { return wt('ufa'); } };
const ST = {
  DONE: ['stDone', 'text-success'], PENDING: ['stPend', 'text-warning'], INIT: ['stPend', 'text-warning'], DEBITED: ['stPend', 'text-warning'],
  REFUNDED: ['stRef', 'text-muted'], FAILED: ['stFail', 'text-danger'],
};
const MIN = 0.01;
const fmt = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtTime = (t) => { try { const d = new Date(t); const p = (n) => (n < 10 ? '0' : '') + n; return p(d.getDate()) + '/' + p(d.getMonth() + 1) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()); } catch (e) { return ''; } };
const auth = () => ({ headers: { Authorization: 'Bearer ' + (localStorage.getItem('auth_token') || '') } });

export async function walletPost(path, body) {
  const r = await instance.post(path, Object.assign({ System: Systems }, body || {}), auth());
  if (!r.data || r.data.status !== 200) throw new Error(wtSrv((r.data && r.data.message) || 'error'));
  return r.data.message;
}
export const getWalletBalances = () => walletPost('/api/v1/wallet/balances', {});

// สีตามธีม: --primary / --secondary ของธีมที่เลือก (fallback ทอง/น้ำเงิน)
const C1 = 'var(--primary, #fbc844)';
const C2 = 'var(--secondary, #2f80ed)';

export default class WalletTransfer extends Component {
  constructor(props) {
    super(props);
    this.state = { lang: wtLang(), loading: true, err: '', W: { main: 0, ufa: 0, ingame: 0, ufaEnabled: true, pending: 0 }, dir: props.initialDir === 'BA' ? 'BA' : 'AB', amount: '', busy: false, cdUntil: 0, now: Date.now(), H: [], hPage: 1, hPages: 1 };
  }
  componentDidMount() { window.addEventListener('site-lang', this.onSiteLang); this.load(); this.loadHistory(1); this._t = setInterval(() => { if (this.state.cdUntil > Date.now()) this.setState({ now: Date.now() }); }, 500); }
  componentWillUnmount() { clearInterval(this._t); window.removeEventListener('site-lang', this.onSiteLang); }

  setLang = (code) => { try { localStorage.setItem('lang', code); } catch (e) { } this.setState({ lang: code }); try { if (window.siteSetLang) window.siteSetLang(code); } catch (e) { } if (this.props.onLang) this.props.onLang(code); };
  onSiteLang = (e) => { const c = (e && e.detail) || wtLang(); if (c !== this.state.lang) this.setState({ lang: c }); };
  load = async () => {
    this.setState({ loading: true, err: '' });
    try { const W = await getWalletBalances(); this.setState({ W, loading: false }); }
    catch (e) { this.setState({ loading: false, err: e.message || wt('loadFail') }); }
  };
  loadHistory = async (page) => {
    try { const h = await walletPost('/api/v1/wallet/transferlog', { page }); this.setState({ H: h.rows || [], hPage: h.page || 1, hPages: h.pages || 1 }); } catch (e) { /* ignore */ }
  };
  maxMove() { const { W, dir } = this.state; return dir === 'AB' ? Number(W.main || 0) : Number(W.ufa || 0); }
  flip = () => this.setState((s) => ({ dir: s.dir === 'AB' ? 'BA' : 'AB', amount: '' }));
  setAll = () => this.setState({ amount: String(Math.floor(this.maxMove() * 100) / 100) });

  submit = async () => {
    const { dir, amount, busy, cdUntil } = this.state;
    if (busy || cdUntil > Date.now()) return;
    const amt = Math.floor(Number(amount) * 100) / 100;
    if (!(amt >= MIN)) return Swal.fire(wt('warn'), wt('needAmount'), 'warning');
    if (amt > this.maxMove()) return Swal.fire(wt('warn'), wt('notEnough', { w: dir === 'AB' ? NAME.A : NAME.B }), 'warning');
    if (dir === 'BA' && Number(this.state.W.ingame || 0) > 0) return Swal.fire(wt('warn'), wt('inGame'), 'warning');
    this.setState({ busy: true });
    try {
      const r = await walletPost('/api/v1/wallet/transfer', { direction: DIR[dir], amount: amt });
      if (r && r.ok && r.result === 'DONE') {
        await Swal.fire({ icon: 'success', title: wt('okTitle'), text: fmt(amt) + ' ฿ → ' + (dir === 'AB' ? NAME.B : NAME.A), timer: 1800, showConfirmButton: false });
        this.setState({ amount: '' });
        if (this.props.onDone) this.props.onDone(r);
      } else if (r && r.ok && r.result === 'PENDING') {
        await Swal.fire(wt('pendTitle'), wtSrv(r.message) || wt('pendText'), 'info');
      } else {
        if (r && r.code === 'cooldown' && r.wait) this.setState({ cdUntil: Date.now() + r.wait * 1000 });
        await Swal.fire(wt('failTitle'), wtSrv(r && r.message) || wt('retry'), 'error');
      }
      if (r && r.ok) this.setState({ cdUntil: Date.now() + 10 * 1000 }); // หน่วงตาม server (WALLET_TRANSFER_COOLDOWN_SEC ค่าเริ่ม 10)
    } catch (e) {
      await Swal.fire(wt('failTitle'), e.message || wt('retry'), 'error');
    }
    this.setState({ busy: false });
    this.load(); this.loadHistory(1);
  };

  render() {
    const { lang, loading, err, W, dir, amount, busy, cdUntil, now, H, hPage, hPages } = this.state;
    const cd = Math.max(0, Math.ceil((cdUntil - now) / 1000));
    const src = dir === 'AB' ? 'A' : 'B', dst = dir === 'AB' ? 'B' : 'A';
    const disabled = busy || cd > 0 || loading || W.ufaEnabled === false;
    const card = (k, v, sub) => (
      <div className={'wtx-wallet ' + (k === src ? 'is-src' : 'is-dst')}>
        <div className="wtx-wallet-ico">{k === 'A' ? '👛' : '⚽'}</div>
        <div className="wtx-wallet-name">{NAME[k]}</div>
        <div className="wtx-wallet-amt">{loading ? <span className="wtx-skel" /> : <>{fmt(v)}<small> ฿</small></>}</div>
        <div className="wtx-wallet-tag">{k === src ? wt('from') : wt('to')}</div>
        {sub ? <div className="wtx-wallet-sub">{sub}</div> : null}
      </div>
    );
    return (
      <div className="wtx animated animatedFadeInUp fadeInUp" key={lang}>
        <style>{WTX_CSS}</style>
        <div className="wtx-wrap">
          <div className="wtx-head">
            <div>
              <div className="wtx-title">⇄ {wt('title')}</div>
              <div className="wtx-subtitle">{NAME.A} ↔ {NAME.B}</div>
            </div>
          </div>

          {err ? <div className="wtx-alert is-err">{err}</div> : null}
          {!loading && W.ufaEnabled === false ? <div className="wtx-alert is-warn">{wt('disabled')}</div> : null}
          {Number(W.pending || 0) > 0 ? <div className="wtx-alert is-warn">{wt('pending', { n: W.pending })}</div> : null}

          <div className="wtx-panel wtx-hero">
            <button type="button" className="wtx-refresh" onClick={this.load} disabled={loading} title={wt('refresh')}>⟳</button>
            <div className="wtx-wallets">
              {card(src, src === 'A' ? W.main : W.ufa, src === 'B' && Number(W.ingame || 0) > 0 ? wt('ingame') + ' ' + fmt(W.ingame) + ' ฿' : null)}
              <button type="button" onClick={this.flip} className="wtx-swap" title={wt('swap')}>⇄</button>
              {card(dst, dst === 'A' ? W.main : W.ufa, dst === 'B' && Number(W.ingame || 0) > 0 ? wt('ingame') + ' ' + fmt(W.ingame) + ' ฿' : null)}
            </div>
          </div>

          <div className="wtx-panel">
            <div className="wtx-label">{wt('amount')}</div>
            <div className="wtx-amount">
              <span className="wtx-cur">฿</span>
              <input type="number" inputMode="decimal" placeholder="0.00" value={amount} min={MIN} step="0.01" onChange={(e) => this.setState({ amount: e.target.value })} />
              <button type="button" className="wtx-all" onClick={this.setAll}>{wt('all')}</button>
            </div>
            <div className="wtx-chips">
              {[100, 300, 500, 1000, 5000].map((v) => (
                <button key={v} type="button" className={String(v) === String(amount) ? 'on' : ''} onClick={() => this.setState({ amount: String(v) })}>{v.toLocaleString()}</button>
              ))}
            </div>
            <div className="wtx-hint">{wt('maxMove')} <b>{fmt(this.maxMove())} ฿</b></div>
            <button type="button" className="wtx-cta" disabled={disabled} onClick={this.submit}>
              {busy ? <span className="wtx-spin" /> : null}
              {busy ? wt('moving') : cd > 0 ? wt('wait', { n: cd }) : wt('confirm')}
            </button>
          </div>

          <div className="wtx-panel">
            <div className="wtx-label d-flex justify-content-between align-items-center"><span>🕘 {wt('history')}</span></div>
            {!H.length ? <div className="wtx-empty">{wt('empty')}</div> : (
              <div>
                {H.map((h) => {
                  const st = ST[h.status] || [h.status, 'text-muted'];
                  const toUfa = h.direction === 'MAIN_TO_UFA';
                  return (
                    <div key={h.transferId} className="wtx-row">
                      <div className={'wtx-row-ico ' + (toUfa ? 'to-b' : 'to-a')}>{toUfa ? '→' : '←'}</div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div className="wtx-row-t">{toUfa ? NAME.A + ' → ' + NAME.B : NAME.B + ' → ' + NAME.A}</div>
                        <div className="wtx-row-s">{fmtTime(h.created)}{h.by === 'SYSTEM' ? ' · ' + wt('bySystem') : ''}</div>
                      </div>
                      <div className="text-right">
                        <div className="wtx-row-a">{fmt(h.amount)} ฿</div>
                        <span className={'wtx-pill ' + st[1]}>{wt(st[0])}</span>
                      </div>
                    </div>
                  );
                })}
                {hPages > 1 ? (
                  <div className="wtx-pager">
                    <button type="button" disabled={hPage <= 1} onClick={() => this.loadHistory(hPage - 1)}>‹</button>
                    <span>{hPage} / {hPages}</span>
                    <button type="button" disabled={hPage >= hPages} onClick={() => this.loadHistory(hPage + 1)}>›</button>
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

// สไตล์หน้าโยกเครดิต (ใช้สีธีม --primary / --secondary)
const WTX_CSS = `
.wtx{padding:10px 6px 90px;color:#fff}
.wtx-wrap{max-width:560px;margin:0 auto}
.wtx-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;gap:8px}
.wtx-title{font-size:22px;font-weight:800;color:${C1};text-shadow:0 2px 10px rgba(0,0,0,.35)}
.wtx-subtitle{font-size:12px;opacity:.75}
.wtx-panel{position:relative;background:linear-gradient(160deg,rgba(255,255,255,.10),rgba(255,255,255,.03));border:1px solid rgba(255,255,255,.14);
  border-radius:18px;padding:16px;margin-bottom:14px;box-shadow:0 10px 28px rgba(0,0,0,.35);backdrop-filter:blur(6px)}
.wtx-hero{background:linear-gradient(135deg,rgba(0,0,0,.45),rgba(0,0,0,.2)),radial-gradient(circle at 0% 0%,${C1} 0%,transparent 55%),radial-gradient(circle at 100% 100%,${C2} 0%,transparent 55%);padding:18px 12px}
.wtx-refresh{position:absolute;top:8px;right:10px;width:30px;height:30px;border-radius:50%;border:1px solid rgba(255,255,255,.35);background:rgba(0,0,0,.35);color:#fff;font-size:16px;line-height:1}
.wtx-wallets{display:flex;align-items:stretch;gap:8px}
.wtx-wallet{flex:1;min-width:0;border-radius:14px;padding:12px 10px;text-align:center;background:rgba(0,0,0,.42);border:1.5px solid rgba(255,255,255,.12);transition:.2s}
.wtx-wallet.is-src{border-color:${C1};box-shadow:0 0 0 3px rgba(251,200,68,.18) inset}
.wtx-wallet-ico{font-size:22px;line-height:1}
.wtx-wallet-name{font-size:13px;opacity:.85;margin-top:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.wtx-wallet-amt{font-size:21px;font-weight:800;margin-top:2px;color:#fff;word-break:break-all}
.wtx-wallet-amt small{font-size:12px;opacity:.75}
.wtx-wallet-tag{display:inline-block;margin-top:6px;font-size:11px;font-weight:700;padding:2px 10px;border-radius:999px;background:rgba(255,255,255,.12)}
.wtx-wallet.is-src .wtx-wallet-tag{background:${C1};color:#111}
.wtx-wallet-sub{font-size:11px;opacity:.8;margin-top:4px}
.wtx-swap{align-self:center;flex:0 0 46px;width:46px;height:46px;border-radius:50%;border:3px solid rgba(0,0,0,.35);background:${C1};color:#111;font-size:22px;font-weight:900;
  box-shadow:0 6px 16px rgba(0,0,0,.45);transition:transform .3s}
.wtx-swap:active{transform:rotate(180deg) scale(.95)}
.wtx-label{font-size:14px;font-weight:700;margin-bottom:8px;opacity:.9}
.wtx-amount{display:flex;align-items:center;background:rgba(0,0,0,.45);border:1.5px solid rgba(255,255,255,.18);border-radius:14px;padding:4px 4px 4px 14px}
.wtx-amount:focus-within{border-color:${C1}}
.wtx-cur{font-size:20px;font-weight:800;color:${C1};margin-right:6px}
.wtx-amount input{flex:1;min-width:0;background:transparent;border:0;outline:0;color:#fff;font-size:24px;font-weight:800;height:46px}
.wtx-amount input::placeholder{color:rgba(255,255,255,.35)}
.wtx-all{border:0;border-radius:10px;padding:0 16px;height:42px;font-weight:800;background:${C1};color:#111}
.wtx-chips{display:flex;gap:6px;margin-top:10px}
.wtx-chips button{flex:1;border-radius:999px;padding:7px 0;font-size:13px;font-weight:700;color:#fff;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.2)}
.wtx-chips button.on{background:${C1};color:#111;border-color:${C1}}
.wtx-hint{font-size:12px;opacity:.8;margin-top:10px}
.wtx-hint b{color:${C1}}
.wtx-cta{width:100%;margin-top:12px;height:52px;border:0;border-radius:14px;font-size:18px;font-weight:800;color:#111;
  background:linear-gradient(180deg,#ffe58a,${C1});box-shadow:0 8px 20px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;gap:8px}
.wtx-cta:disabled{filter:grayscale(.7);opacity:.6}
.wtx-spin{width:18px;height:18px;border:3px solid rgba(0,0,0,.25);border-top-color:#111;border-radius:50%;animation:wtxspin .8s linear infinite}
@keyframes wtxspin{to{transform:rotate(360deg)}}
.wtx-skel{display:inline-block;width:80px;height:20px;border-radius:6px;background:linear-gradient(90deg,rgba(255,255,255,.08),rgba(255,255,255,.25),rgba(255,255,255,.08));background-size:200% 100%;animation:wtxsk 1.2s infinite}
@keyframes wtxsk{to{background-position:-200% 0}}
.wtx-alert{border-radius:12px;padding:9px 12px;margin-bottom:12px;font-size:14px;font-weight:600}
.wtx-alert.is-warn{background:rgba(255,193,7,.16);border:1px solid rgba(255,193,7,.55);color:#ffe08a}
.wtx-alert.is-err{background:rgba(220,53,69,.18);border:1px solid rgba(220,53,69,.6);color:#ffb3ba}
.wtx-empty{text-align:center;padding:18px 0;opacity:.6;font-size:14px}
.wtx-row{display:flex;align-items:center;gap:10px;padding:10px 0;border-bottom:1px dashed rgba(255,255,255,.14)}
.wtx-row:last-of-type{border-bottom:0}
.wtx-row-ico{flex:0 0 34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:900;background:rgba(255,255,255,.1)}
.wtx-row-ico.to-b{color:${C1}}
.wtx-row-t{font-size:14px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.wtx-row-s{font-size:11px;opacity:.65}
.wtx-row-a{font-size:15px;font-weight:800}
.wtx-pill{display:inline-block;font-size:11px;font-weight:700;padding:1px 8px;border-radius:999px;background:rgba(255,255,255,.1)}
.wtx-pager{display:flex;justify-content:center;align-items:center;gap:12px;margin-top:10px}
.wtx-pager button{width:32px;height:32px;border-radius:50%;border:1px solid rgba(255,255,255,.3);background:rgba(0,0,0,.3);color:#fff}
.wtx-pager button:disabled{opacity:.35}
`;

// เช็คก่อนเข้าเกมกระดาน UFA (partner = UEFA): กระเป๋า UFA ว่าง → ถามให้ไปโยกก่อน (เหมือนเว็บลาว)
//   คืน true = เข้าเกมต่อได้ · false = ไม่เข้า (ผู้ใช้ไปหน้าโยก / ยกเลิก)
export async function ufaGateBeforeLaunch(partner, goTransfer) {
  if (String(partner || '').toUpperCase() !== 'UEFA') return true;
  try {
    const b = await getWalletBalances();
    if (b && b.ufaEnabled === false) return true;
    if (b && (Number(b.ufa) > 0 || Number(b.ingame) > 0)) return true;
    const r = await Swal.fire({
      icon: 'info', title: wt('gateTitle'),
      html: wt('gateHtml', { m: fmt(b && b.main) }),
      showCancelButton: true, showDenyButton: true, confirmButtonText: wt('gateGo'), denyButtonText: wt('gatePlay'), cancelButtonText: wt('cancel'),
    });
    if (r.isConfirmed) { if (goTransfer) goTransfer(); return false; }
    return !!r.isDenied; // เข้าเกมเลย (เช่น มีบิลบอลค้าง)
  } catch (e) { return true; }
}
